import { axios } from '@repo/http';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orgTeamList } from '../organization-team-list';
/**
 * POST create new team.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useCreateTeam(orgName) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { name } = param;
            return axios.post("/v2/organization/".concat(orgName, "/team"), {
                name
            });
        },
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey: orgTeamList.teamList({
                    organization: orgName
                }).queryKey
            });
        }
    });
}
